import React, { TextareaHTMLAttributes, useLayoutEffect, useRef } from "react";

export interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
	ref?: React.RefObject<HTMLTextAreaElement>;
	minHeightPx?: number;
}

export default function AutosizeTextArea(props: Props) {
	const { minHeightPx, ...domProps } = props;
	const textareaRef = props.ref ?? useRef<HTMLTextAreaElement>(null);
	const minHeight = minHeightPx ?? 32;

	useLayoutEffect(() => {
		if (!textareaRef.current) return;
		textareaRef.current.style.height = "inherit";
		const height = Math.max(textareaRef.current.scrollHeight + 3, minHeight);
		textareaRef.current.style.height = `${height}px`;
	});

	return (
		<textarea
			{...domProps}
			className={`${props.className} resize-none w-full`}
			ref={textareaRef}
		/>
	);
}
